import { isValuePresent } from 'helpers/utils';
import { type ChangeEvent, type FC, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { TextField } from '../TextField';
import type { PercentageInputProps } from './PercentageInput.types';

const PercentageInput: FC<PercentageInputProps> = ({ initialValue, onInputChange, ...rest }) => {
  const [value, setValue] = useState(
    isValuePresent(initialValue) ? (initialValue as number) * 100 : '',
  );

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const v = event.target.value;
    const inputValue = parseFloat(v || '0');

    const decimalValue = inputValue / 100;

    setValue(v);
    onInputChange(decimalValue);
  };

  return (
    <NumericFormat
      {...rest}
      value={value}
      suffix="%"
      onChange={handleChange}
      allowNegative={false}
      decimalScale={2}
      isAllowed={(values) => (values.floatValue ?? 0) <= 100}
      customInput={TextField}
      autoComplete="off"
    />
  );
};

export default PercentageInput;
